<div fxLayout="column" class="page-container">
  <div fxLayout="column" fxFlex="25" class="eon-backdrop" fxLayoutAlign="center center">
    <div fxLayoutAlign="end start" class="eon-logo" fxFlex="40">
      <mat-icon svgIcon="logo-red"></mat-icon>
    </div>
    <div class="splash-container">
      <p class="upper-paragraph">Well played! Congratulations!</p>
      <h1>You are TechCore!</h1>
      <p *ngIf="config$ | async as config" class="lower-paragraph">{{config.rewardMessage}}</p>
    </div>
  </div>

  <!-- Show loading message while fetching scores -->
  <div *ngIf="loading" class="loading-container"  fxFlex="65" fxLayoutAlign="center start">
    <eon-ui-preloader-squares></eon-ui-preloader-squares>
  </div>

  <!-- Show the leaderboard only when loading is finished -->
  <div *ngIf="!loading" fxFlex="65" fxLayout="column" class="score-container" fxLayoutAlign="start center" fxLayoutGap="10px">
    <!-- If scores exist, display them -->
    <ng-container *ngIf="scores.length > 0; else noScores">
      <tech-core-quiz-scoreboard-card
        *ngFor="let score of scores; let i = index"
        [rank]="(i +1).toString()"
        [userName]="score.userName"
        [score]="score.score">
      </tech-core-quiz-scoreboard-card>
    </ng-container>

    <!-- Fallback when no scores exist -->
    <ng-template #noScores>
        <p class="empty-score-container" fxLayoutAlign="center center">No one has played yet!<br> Be the first to get on the leaderboard.</p>
    </ng-template>

    <ng-container *ngIf="hasQueryParam">
      <tech-core-quiz-divider></tech-core-quiz-divider>

      <tech-core-quiz-scoreboard-card [rank]="this.rank" [userName]="this.userName" [score]="this.userScore" [active]=false></tech-core-quiz-scoreboard-card>
    </ng-container>

  </div>
  <div class="bottom-content" fxLayout="column" fxLayoutAlign="end center">
    <eon-ui-button fullWidth=true text="Back to Startscreen" class="primary-button" (click)="navigateToSplash()"></eon-ui-button>
  </div>
</div>
